// extracted by mini-css-extract-plugin
export default {"l":"_895da3e3fd"};